import { createApp } from "vue";
import App from "./App.vue";
import router from "./rotuer";

createApp(App).use(router).mount("#app");
